
import React from 'react';

const InstitutionHierarchyManagement = () => {
    return (
        <div className="p-4">
            <h1 className="text-2xl font-bold">Institution Hierarchy Management</h1>
            <p>Coming Soon...</p>
        </div>
    );
};

export default InstitutionHierarchyManagement;
